export const SELECT_APP = "SELECT_APP";
export const GET_MENU = "GET_MENU";
export const SET_CHAT_ITEMS = "SET_CHAT_ITEMS";
export const FLUSH_CHAT_ITEMS = "FLUSH_CHAT_ITEMS";